module.exports = __webpack_public_path__ + "img/mindful_days_180--active.ea380a03.svg";